var map = {
	"./1.png": 811546,
	"./2.png": 926354,
	"./3.png": 824479,
	"./4.png": 493235,
	"./5.png": 709343,
	"./6.png": 716055,
	"./7.png": 81588,
	"./8.png": 161894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 580606;